export const LANGUAGE_CODE_COOKIE_NAME = {
  BETA: 'lc-tacbus',
  GAMMA: 'lc-main',
  PROD: 'lc-main',
};

export const LOCALE_LOCAL_STORAGE_KEY = 'defaultLocale';
export const LANGUAGE_TOGGLE_UNSUPPORTED = 'Only English language is supported for this page. Other language support for this page is coming soon.';
